/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GenerationJobReprocess = {
  mode: GenerationJobReprocess.mode;
};
export namespace GenerationJobReprocess {
  export enum mode {
    FULL = 'full',
  }
}

